module.exports = __webpack_public_path__ + "static/media/ana_baptista.a954353f.jpg";